import { Directive } from '@angular/core';

@Directive({
  selector: 'a[target=_blank]',
  host: {
    '[attr.rel]': '"noopener noreferrer"',
  },
})
export class TargetBlankDirective {}
